// Foundation JavaScript
// Documentation can be found at: http://foundation.zurb.com/docs

jQuery(document).ready(function() {
  jQuery(document).foundation();

  return jQuery(document).on("click", ".m-icon, .js-off-canvas-overlay", function() {
    return jQuery(".icon").toggleClass("active");
  });
});

jQuery('[data-toggle]').on('click', function() {

	jQuery(document).trigger('click.zf.trigger', '[data-toggle]');

});


/* Slick Slider */

jQuery(document).ready(function() {

	jQuery('.route-carousel').slick({
	  	slidesToShow: 1,
	  	centerMode: false,
	  	//centerPadding: '50px',
	    infinite: true,
	    arrows: true,
	    dots: false,
	    autoplay: true,
	    initialSlide: 0,
	    variableWidth: true,
	    swipeToSlide: true,
	});

	jQuery('.nearby-route-carousel').slick({
	  	slidesToShow: 1,
	  	centerMode: false,
	    infinite: true,
	    arrows: true,
	    dots: false,
	    autoplay: false,
	    initialSlide: 0,
	    variableWidth: true,
	    swipeToSlide: true,
	});

});


/* Make Embeds Responsive */

jQuery(document).ready(function() {

	jQuery('.single-post iframe').wrap('<div class="flex-video" />');

});


/* Facebook Sharer */

function fbShare(url, title, descr, image, winWidth, winHeight) {
    var winTop = (screen.height / 2) - (winHeight / 2);
    var winLeft = (screen.width / 2) - (winWidth / 2);
    window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}

function googleShare(url, winWidth, winHeight) {
    window.open("https://plus.google.com/share?url=" + url + "", "", "width=" + winWidth + ", height=" + winHeight + "");
}


/* Smooth Scroll */

jQuery(function($) {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1200);
        return false;
      }
    }
  });
});


/* Magnific Popup */

jQuery(function() {


	jQuery('.gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}

	});

});


/* Gallery */

jQuery(".gallery").justifiedGallery({
	rowHeight : 200,
	lastRow : 'justify',
	captions : false,
	margins : 10
});


jQuery(function() {

	//jQuery('.modal').fluidbox();

	jQuery('.filter-bar-toggle, #toggle-search').click(function() {

		jQuery('.filter-bar-expand').toggle();
		jQuery('.filter-bar-toggle').toggleClass('open');

	});

	jQuery('#like-route').click(function() {
		jQuery(this).toggleClass('fal');
		jQuery(this).toggleClass('fas');
	});

});
